// extracted by mini-css-extract-plugin
export default {"layout":"Empty_layout__Urf5a"};